import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';

import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
@Component({
    selector: 'option-configuration',
    templateUrl: './option-configuration.component.html',
    styleUrls: ['./option-configuration.component.scss'],
    standalone: false
})
export class OptionConfigurationComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.displayErrors();
    if (this.form.valid) {
      this.subscriptionFacade.setStepName('optionConfiguration');
      this.subscriptionFacade.submitPledge(this);
    }
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
